import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=41547941&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=41547941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41547941",
  null
  
)

export default component.exports